import { Box, List, ListItem, Link } from '@mui/material';
import React from 'react';
import SidebarScss from './SidebarComp.module.scss';
import Reklam from '../../Common/Image/reklam.jpg';


function SidebarComp() {
    return (
        <aside className={SidebarScss.sidebar}>
            <Box className={SidebarScss.SidebarBoxDesing}>
                <input type='text' placeholder='Search ...'></input>
                <span></span>
            </Box>
            <Box className={SidebarScss.SidebarBoxDesing} sx={{ mt: "30px" }}>
                <h4 className={SidebarScss.SidebarBoxDesingName}>recent posts</h4>
                <span></span>
                <List className={SidebarScss.NavDesing}>
                    <ListItem>
                        <Link href='#'>On the head with free internet</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Turpisdolor</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Condimentum</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Proinnec</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Euhendrerit</Link>
                    </ListItem>
                </List>
            </Box>
            <Box className={SidebarScss.SidebarBoxDesing} sx={{ mt: "30px" }}>
                <h4 className={SidebarScss.SidebarBoxDesingName}>recent comments</h4>
                <span></span>
                <List className={SidebarScss.NavDesing}>
                    <ListItem>
                        <Link href='#'>On the head with free internet</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Turpisdolor</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Condimentum</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Proinnec</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Euhendrerit</Link>
                    </ListItem>
                </List>
            </Box>
            <Box className={SidebarScss.SidebarBoxDesing} sx={{ mt: "30px" }}>
                <h4 className={SidebarScss.SidebarBoxDesingName}>archives</h4>
                <span></span>
                <List className={SidebarScss.NavDesing}>
                    <ListItem>
                        <Link href='#'>June 2022</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>May 2022</Link>
                    </ListItem>
                </List>
            </Box>
            <Box className={SidebarScss.SidebarBoxDesing} sx={{ mt: "30px" }}>
                <h4 className={SidebarScss.SidebarBoxDesingName}>categories</h4>
                <span></span>
                <List className={SidebarScss.NavDesing}>
                    <ListItem>
                        <Link href='#'>On the head with free internet</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Turpisdolor</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Condimentum</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Proinnec</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Euhendrerit</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>On the head with free internet</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Turpisdolor</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Condimentum</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Proinnec</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Euhendrerit</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>On the head with free internet</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Turpisdolor</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Condimentum</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Proinnec</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Euhendrerit</Link>
                    </ListItem>
                </List>
            </Box>
            <Box className={SidebarScss.SidebarBoxDesing} sx={{ mt: "30px" }}>
                <h4 className={SidebarScss.SidebarBoxDesingName}>Meta</h4>
                <span></span>
                <List className={SidebarScss.NavDesing}>
                    <ListItem>
                        <Link href='#'>On the head with free internet</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Turpisdolor</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Condimentum</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Proinnec</Link>
                    </ListItem>
                    <ListItem>
                        <Link href='#'>Euhendrerit</Link>
                    </ListItem>
                </List>
            </Box>

            <Box className={SidebarScss.SidebarBoxAdvertising} sx={{ mt: "30px" }}>
                <img src={Reklam} alt=''></img>
                <span className={SidebarScss.SidebarBoxAdvertisingDis}>
                    <span><i>50%</i></span>
                    <p><i>discount</i></p>
                </span>
            </Box>
        </aside>
    )
}


export default SidebarComp;